var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.bannerItems.length > 0)?_c('banner-section',{attrs:{"items":_vm.bannerItems}}):_vm._e(),_c('intro-section'),_c('series-section',{attrs:{"items":_vm.goodsSeries}}),_c('about-section'),_c('news-section',{attrs:{"items":_vm.newsList}}),_c('store-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }